import { reverseUserRoute } from 'routes';

export function applySKUInterface(sku) {
  return {
    ...sku,
    permalink: `${reverseUserRoute('Space')}/${sku.id}`,
    // Add additional fields or transformations here
  };
}

//orders work on country name only not following uid as value, so this is to to transform the countries list such that text: country_name and value also same as text(country_name)
export const applyOrdersCountryListInterface = (list) => {
  if (!!!list || !!!list.length) {
    return [];
  }
  const updatedList = list?.map((country) => ({
    ...country,
    value: country.text,
  }));

  return updatedList;
};
